export default __webpack_public_path__ + "static/media/TrustedDev-inactiveTab.83a64ab2.svg";